import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import {environment} from "../../environments/environment";
import {LoginComponent} from "./login/login.component";
import {AuthService} from "./auth.service";
import {FirebaseRoutingModule} from "./firebase-routing.module";
import {PlatformModule} from "../platform/platform.module";
import {RegisterComponent} from "./register/register.component";


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.settings.firebase),
    AngularFireAuthModule,
    PlatformModule,
    FirebaseRoutingModule
  ],
  declarations: [LoginComponent, RegisterComponent],
  providers: [AuthService],
  exports: [LoginComponent, RegisterComponent]

})
export class FirebaseModule { }
